<template>
  <div>
  <el-dialog v-loading="loading.dialog" class="task_model_dialog" top="5vh" center :title="newTitle" width="80%"
    :before-close="handleClose" :visible.sync="dialogVisible" :append-to-body="true" :close-on-click-modal="false">
    <Share v-if="!isCreate" :shareInfo="{ pid: form.pid, tid: form.id, type: 'task', tabid: tabid }" />
    <el-form size="mini" ref="form" :rules="rules" :model="form">
      <el-form-item label="标题" prop="name" :label-width="formLabelWidth">
        <el-input v-model="form.name" autocomplete="off" :disabled="isEditTestTask"></el-input>
      </el-form-item>
      <el-form-item v-if="form.prd_link" label="PRD链接"  :label-width="formLabelWidth" prop="prdLink">
        <div @click="linkFn(form.prd_link)"
             style="text-decoration: underline;color: #409EFF;cursor: pointer;display: inline-block;">
          {{ form.prd_link }}</div>
      </el-form-item>
      <el-form-item v-if="form.techDocLink" label="技术文档链接" :label-width="formLabelWidth" prop="techDocLink">
        <div @click="linkFn(form.techDocLink)"
             style="text-decoration: underline;color: #409EFF;cursor: pointer;display: inline-block;">
          {{ form.techDocLink }}</div>
      </el-form-item>
<!--      <el-form-item label="技术描述" v-if="form.techDesc" prop="techDesc" :label-width="formLabelWidth">
        <el-input type="textarea" disabled="true" :rows="6" placeholder="请输入内容" v-model="form.techDesc" />
      </el-form-item>-->
      <el-form-item label="任务内容" prop="taskDetail" :label-width="formLabelWidth">
        <el-input type="textarea" :rows="6" placeholder="请输入内容" v-model="form.taskDetail" :disabled="isEditTestTask">
        </el-input>
      </el-form-item>
      <div style="display: flex;">
        <el-form-item label="测试人员" prop="testerId" :label-width="formLabelWidth">
          <el-select autocomplete="off" size="mini" v-model="form.testerId" filterable placeholder="请选择测试人员" :disabled="isEditTestTask">
            <el-option v-for="(key, value)  in allUserList.ALLUSERTYPE4" :key="key" :label="key" :value="value" />
          </el-select>
        </el-form-item>
        <el-form-item label="预估工时" prop="estimateWorkHour" :label-width="formLabelWidth">
          <el-input style="width: 92%;" v-model="form.estimateWorkHour" type="number" placeholder="小时" @change="handleEdit" :disabled="isEditTestTask">时</el-input>
          <el-tooltip class="item" effect="light" placement="top">
            <div slot="content">
              <span>一天6工时，最多30工时</span>
            </div>
            <i class="el-icon-question" style="color: #409EFF;"></i>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="计划完成日期" prop="planFinishDate" :label-width="formLabelWidth">
          <el-date-picker value-format="yyyy-MM-dd" v-model="form.planFinishDate" type="date" placeholder="请选择时间"
                          :picker-options="pickerOptions_plt" @change="changeDate" :disabled="isEditTestTask"/>
        </el-form-item>
      </div>
      <div style="display: flex" v-if="isUpdate">
        <el-form-item label="任务状态"  :label-width="formLabelWidth">
          <el-input :value="form.test_status_desc" type="text" :disabled="true">时</el-input>
        </el-form-item>
        <el-form-item label="进度"  :label-width="formLabelWidth">
          <el-input :value="form.processRate" type="text" :disabled="true">时</el-input>
        </el-form-item>
        <el-form-item label="BUG"  :label-width="formLabelWidth">
          <el-input :value="form.bugHandlingcount + '/' + form.bugTotal" type="text" :disabled="true">时</el-input>
        </el-form-item>
      </div>
      <div>
      <el-form-item :label-width="formLabelWidth">
        <div class="task-line"><label>分配任务</label></div>
      </el-form-item>
        <el-form-item label=""  :label-width="formLabelWidth">
          <el-button size="mini" :disabled="!isReviewerAction" @click="onAllocationTask('allocation')"  type="primary">添加</el-button>
        </el-form-item>
      <el-form-item :label-width="formLabelWidth">
        <el-table :data="addData" border style="width: 100%">
          <el-table-column prop="id" label="开发任务ID" width="180">
          </el-table-column>
          <el-table-column prop="taskName" label="开发任务名称" width="180">
            <template slot-scope="scope">
              <span class="table_text_click_new" @click="linkToModel(scope.row)">{{scope.row.taskName}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="module" label="系统">
          </el-table-column>
          <el-table-column prop="developer" label="开发人员">
            <template slot-scope="scope">
              <span>
                {{scope.row.developer.nameZh ? scope.row.developer.nameZh: ''}}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="status_desc" label="状态">
          </el-table-column>
          <el-table-column prop="bugHandlingcount" label="BUG">
            <template slot-scope="scope">
              <span>{{scope.row.bugHandlingcount}} / {{scope.row.bugTotal}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="status_desc" label="上次部署状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 3">
                     {{scope.row.is_tester_stagCodeDeploy === '未部署' ? scope.row.is_tester_testCodeDeploy : scope.row.is_tester_stagCodeDeploy}}
              </span>
              <span v-else>
                {{scope.row.desc ? scope.row.desc:scope.row.is_tester_testCodeDeploy}}
              </span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="160"  v-if="isUpdate && isTester">
            <template slot-scope="scope">
              <el-button :disabled="!(scope.row.status_desc==='已提测'&&isTester)" @click="addBugTask(scope.row)" type="primary" size="small">+BUG</el-button>
              <el-button :disabled="!(scope.row.status_desc==='已提测'&&isTester)"   @click="toArrange(scope.row)" type="primary" size="small">部署</el-button>
            </template>
          </el-table-column>
          <el-table-column  align="center" label="操作" width="160" v-else>
            <template slot-scope="scope">
              <el-button  @click="linkToModel(scope.row)" type="warning" size="small">详情
              </el-button>
              <el-button :disabled="!isReviewerActionDelete(scope.row.status)"  :loading="loading['task' + scope.row.taskId]" @click="onDeleteTestTask(scope.row)" type="danger" size="small">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
        <div v-if="isUpdate && isTester && form.test_status > 0">
        <el-form-item :label-width="formLabelWidth">
          <div class="task-line"><label>工作区</label></div>
        </el-form-item>
        <div v-if="isUpdate && form.test_status > 0" style="display: flex;">
        <el-form-item label="测试计划" :label-width="formLabelWidth">
          <MetersphereTestplanBind :taskInfo="{ id: form.id, env: 'test' }" :getPlanId="getPlanId"/>
        </el-form-item>
        </div>
        </div>
      </div>
      <el-form-item v-if="form.id && historylist.length" label="任务历史" :label-width="formLabelWidth">
        <TaskHistory :list="historylist" />
      </el-form-item>
      <el-form :model="form" v-if="!isCreate">
        <el-form-item class="comment_warp" label="评论" :model="form" :label-width="formLabelWidth">
          <Comment  :id="form.id" :busiId="form.id"  type="4"/>
        </el-form-item>
      </el-form>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button v-show="step === 1" v-if="!isCreate && isReviewer||getIsShowEdit" type="primary" @click="changeStep">编 辑</el-button>
      <el-button  v-if="isCreate || step === 2" style="margin-left:0;"
        :loading="loading.submit" type="warning" @click="onSubmit">{{ isCreate ? '创 建' : '提 交' }}</el-button>
<!--      <el-button type="danger" v-if="!isCreate && isAdmin && !isHistoryReviewed" @click="onDelete">删 除
      </el-button>-->
      <el-button v-if="form.test_status === 0 && isTester && !isCreate" type="primary" :loading="loading.submit"  @click="submitAction(1)"> 开启用例 </el-button>
      <el-button v-if="form.test_status === 1 && isTester && !isCreate" type="primary" :loading="loading.submit"   @click="submitAction(2)"> 提交用例 </el-button>
      <el-button v-if="form.test_status === 3 && isTester && !isCreate" type="primary" :loading="loading.submit"   @click="submitAction(3,'test')"> 开始测试 </el-button>
      <el-button v-if="form.test_status === 4 && isTester && !isCreate" type="primary" :loading="loading.submit"  @click="submitAction(4, 'staging')"> 提交预发测试 </el-button>
      <el-button v-if="form.test_status === 5 && isTester && !isCreate" type="primary" :loading="loading.submit"  @click="submitFinishTest()"> 完成测试 </el-button>
      <el-button v-if="form.test_status === 9&&form.isJointCommissioning===1 && isTester && !isCreate" type="primary" :loading="loading.submit"  @click="submitUat(true)"> 提交客户联调 </el-button>
      <el-button v-if="((form.test_status === 9&&form.isJointCommissioning===0)||form.test_status === 10) && isTester && !isCreate" type="primary" :loading="loading.submit"  @click="submitUat()"> 提交UAT </el-button>
      <el-button type="primary" v-if="!isCreate && form.test_status > 3 && isTester && (form.test_status < 5 || form.test_status === 9   || form.test_status === 10) && !isCreate" :loading="loading.skip"  @click="submitAction(6)"> 跳 过 </el-button>
      <el-button type="primary" v-if="!isCreate && form.test_status > 3 && isTester && form.test_status === 5 && !isCreate" :loading="loading.skip"  @click="submitFinishTest()"> 跳 过 </el-button>
      

      <el-button type="success" @click="handleClose">关 闭</el-button>
    </div>
    <AllocationTask v-if="dialogVisibleAllocationTask" :dialogVisible='dialogVisibleAllocationTask' :hideDialogVisible="handleAllocationClose"  :demand_id="formInfo.id" :getChooseTask="getChooseTask" @change="change" :addData="addData"/>
    <TestEnvArrange v-if="dialogVisibleTestEnv" :dialogVisible='dialogVisibleTestEnv' :hideDialogVisible="handleTestEnvClose" :formInfo="arrangeInfo"></TestEnvArrange>
    <PreEnvTestArrange v-if="dialogVisibleTestPreEnv" :dialogVisible='dialogVisibleTestPreEnv' :hideDialogVisible="handleTestPreEnvClose" :formInfo="arrangeInfo"></PreEnvTestArrange>
    <UatTestArrange v-if="dialogVisibleTestUatEnv" :dialogVisible='dialogVisibleTestUatEnv' :hideDialogVisible="handleTestUatEnvClose" :formInfo="arrangeInfo"></UatTestArrange>
    <create v-if="dialogVisibleCreateBug" :dialogVisible='dialogVisibleCreateBug'  :hideDialogVisible="handleCreateBug"  :test_task_id="test_task_id" :dev_task_id="dev_task_id" />
    <Task v-if="dialogVisibleTask" :dialogVisible='dialogVisibleTask' :hideDialogVisible="handleTaskClose" :formInfo="formTaskInfo" />
    <el-dialog center :append-to-body="true" title="延期原因" :visible.sync="dialogVisibleDelay" width="40%">
      <el-form :model="pSubmitForm" :rules="pSubmitRules" ref="pSubmitForm">
        <el-form-item label="延期类型" prop="reasonCode" :label-width="formLabelWidth" >
          <el-select v-model="pSubmitForm.reasonCode" placeholder="请选择" >
            <el-option v-for="(key, val) in typeList" :key="key" :label="key" :value="val" />
          </el-select>
        </el-form-item>
        <el-form-item label="原因" prop="reasonDetail" :label-width="formLabelWidth" >
          <el-input type="textarea" rows="3" v-model="pSubmitForm.reasonDetail" autocomplete="off" placeholder="延期原因" />
        </el-form-item>
        <el-form-item label=""  :label-width="formLabelWidth" >
          <el-button size="small" type="primary" :loading="loading.submitDelay" @click="onSubmitDelay">确 定</el-button>
          <el-button size="small" @click="dialogVisibleDelay = false">取 消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </el-dialog>

  </div>
</template>
<script>
import { create } from './bug'
import { Editor } from "@/components/index.js";
import Comment from '@/views/tops/devOps/producerSpace/components/project/comment.vue'
import AllocationTask from "@/views/tops/devOps/producerSpace/components/testTask/allocationTask.vue";
import TestEnvArrange from "@/views/tops/devOps/producerSpace/components/testEnvArrange.vue";
import PreEnvTestArrange from "@/views/tops/devOps/producerSpace/components/preEnvTestArrange.vue";
import UatTestArrange from "@/views/tops/devOps/producerSpace/components/uatTestArrange.vue";

import {
  MetersphereTestplanBind
} from "@/views/tops/devOps/components/model/index.js";
import {
  getDevOpsSpaceTaskDetailApi,
  postDevopsSpaceTaskUpdateApi,
  postDevOpsSpaceDeleteTaskApi,
  getListMetersphereBugsApi,
  postDevOpsSpaceCreateTestTaskApi,
  getDevOpsSpaceTestTaskApi,
  getDevOpsSpaceDevelopTestTaskApi,
  postDevOpsSpaceUpdateTestTaskApi,
  postDevOpsSpaceSUbmitTestTaskApi,
  getDevOpsSpaceHistoryTaskListApi,
  postDevOpsSpaceUserPmEditStatusApi,
  getDevOpsSpaceDelayReasonListApi,
  postDevOpsSpaceSUbmitDelayReasonApi
} from "@/server/tops/devOps";
import { formatStrToArr } from "@/views/tops/devOps/components/util.js"
import { postDevOpsSpaceCreateTaskApi } from "../../../../../server/tops/devOps";
import { TaskHistory } from '@/views/tops/devOps/components/list'
import { TableBug } from '@/views/tops/devOps/components/table'
import Share from "./share.vue"
import { mapState } from "vuex";
import Task from "@/views/tops/devOps/producerSpace/components/task.vue";
export default {
  components: {Task, Editor, Comment, TaskHistory, Share, TableBug, AllocationTask,MetersphereTestplanBind ,TestEnvArrange, PreEnvTestArrange, UatTestArrange, create},
  props: {
    formInfo: {
      type: Object,
      default: function () {
        return {}
      },
    },
    tabid: {
      type: String,
      default: '',
    },
    back: {
      type: String,
      default: '',
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    }
  },
  data() {
    return {
      addData: [
      ],
      form: {
        taskHistory: [], // 任务历史
        details: '', // 描述富文本内容
        domain: 'ehsy.com',
        pett: '',
        describe:'',
        taskTime: '',
      },
      rules: {
        name: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        testerId: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        estimateWorkHour: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        planFinishDate: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        taskDetail: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
      },
      pSubmitForm:{
        reasonCode:'',
        reasonDetail: '',
      },
      pSubmitRules:{
        reasonCode: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        reasonDetail: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
      },
      formLabelWidth: '140px',
      step: 1, // 1. 编辑 2. 提交
      loading: {
        dialog: false,
        submit: false,
        skip: false,
        submitDelay: false,
      },
      bugOption: {
        count: 0,
        resolved: 0,
        new: 0,
        closed: 0,
        bugs: []
      },
      dialog: {
        bugVisible: false
      },
      username: '',
      pickerOptions_psdt: {
        disabledDate: (time) => {
          return this.disabledDate('psdt', time)
        }
      },
      pickerOptions_pedt: {
        disabledDate: (time) => {
          return this.disabledDate('pedt', time)
        }
      },
      pickerOptions_pstt: {
        disabledDate: (time) => {
          return this.disabledDate('pstt', time)
        }
      },
      pickerOptions_plt: {
        disabledDate: (time) => {
          return this.disabledDate('plt', time)
        }
      },
      link: {
        prdLink: false,
        techDocLink: false
      },
      showDetails: false,
      showLinkTo: false,
      showPLink: false,
      dialogVisibleAllocationTask: false,
      meterspherePlanId: '',
      dialogVisibleTestEnv: false,
      dialogVisibleTestPreEnv: false,
      dialogVisibleTestUatEnv: false,
      dialogVisibleCreateBug: false,
      arrangeInfo: {},
      historylist: [],
      test_task_id: '', //测试任务id
      dev_task_id: '', //开发任务id
      dialogVisibleTask: false,
      formTaskInfo: {},
      userId: '',
      dialogVisibleDelay: false,
      typeList: {},
      stage_liantiao:false
    };
  },
  async created() {
    const {  taskInfo = {}, pid } = this.formInfo;
    const { id = '', openType = '', taskName = '', tester = '', estimateWorkHour = '',  planFinishDate = '',test_status_desc, processRate = '',bugHandlingcount = '', bugTotal = ''} = taskInfo;
    this.form = { ...this.form, id, name:taskName, testerId: tester.id? tester.id: '', estimateWorkHour, test_status_desc,planFinishDate,  processRate, bugHandlingcount, bugTotal}
/*  this.showLinkTo = techDocLink;
    this.showReDetails = techDesc;
    this.showPLink = prdLink;*/
    //获取未开始，进行中的项目
    if(id){
      this.test_task_id = id;
      this.$nextTick(async () => {
         await this.init();
         if(openType !== 'copy'){
           await this.queryDevOpsSpaceDevelopTestTask();
           await this.getHistoryList();
         }
      })
    }/*
    if (id) await this.init();
    if(id) await this.queryDevOpsSpaceDevelopTestTask();*/
    if (this.isCreate) {
      this.step = 2;
    };
    this.username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
    const username = this.username;
    if(this.allUserList.ALLUSERIDLIST1[username]){
      this.userId = this.allUserList.ALLUSERIDLIST1[username];
    }
    },
  computed: {
    ...mapState(
      {
        allSelect: (state) => state.devOps.ALLSELECT,
        allSystem: (state) => state.devOps.ALLSYSTEM,
        allUserList: (state) => state.devOps.ALLUSERLIST,
      }
    ),
    // 是否显示编辑按钮
    showEdit() {
      if (this.isHistoryReviewed) return false;
      if (this.isCreate) return false;
      if (!this.isAdmin) return false;
      return true
    },
    modules() {
      let obj = {}
      const MODULESARR = this.allSelect.MODULESARR || [];
      MODULESARR.filter(itm => itm[2] === this.form.domain).forEach((item) => {
        obj[item[1]] = item[0];
      });
      return obj
    },
    // 判断是否是创建
    isCreate() {
      const { id = '',openType = ''} = this.formInfo?.taskInfo || {};
      return !id || openType === 'copy';
    },
    // 判断是否是创建
    isUpdate(){
      const { id = '',openType = ''} = this.formInfo?.taskInfo || {};
      if(id && openType !== 'copy'){
        return true;
      }
      return false;
    },
    newTitle() {
      if (this.isUpdate) {
        return '[' + this.form.id + ']测试任务-' + this.form.name;
      } else {
        return '测试任务'
      }
    },
    isEditTestTask(){
      return this.step !== 2;
    },
    isTester(){
      if(this.isAdmin || this.isTesterLeader) return true;
      if(this.form.tester){
        return (this.form.tester.nameEn === this.username);
      }
      return false;
    },
    isAdmin(){
      if(this.username){
        if(this.allUserList.ALLUSERTYPE13 && this.allUserList.ALLUSERTYPE13[this.username]) return true
      }
      return false;
    },
    isTesterLeader(){
      if(this.userId && this.form.tester){
        const testerId = this.form.tester.id;
        if(this.allUserList.LEADERUSER && this.allUserList.LEADERUSER[testerId]){
          return this.allUserList.LEADERUSER[testerId] === this.userId;
        }
      }
      return false;
    },
    isReviewerLeader(){
      if(this.userId && this.form.reviewer){
        const reviewerId = this.form.reviewer.id;
        if(this.allUserList.LEADERUSER && this.allUserList.LEADERUSER[reviewerId]){
          return this.allUserList.LEADERUSER[reviewerId] === this.userId ;
        }
      }
      return false;
    },
    isReviewer(){
      if(this.isCreate){
        return true;
      }
      if(this.isAdmin || this.isReviewerLeader) return true;
      if(this.form.reviewer){
        return    this.form.reviewer.nameEn === this.username;
      }
      return false;
    },
    isHistoryReviewed() {
      return this.form.reviewed_status === 'history_reviewed'
    },
    isReviewerAction(){
      if(this.isReviewer && this.step === 2){
        return true;
      }
      return false;
    },
  },
  methods: {
    getIsShowEdit(){
      let userId =JSON.parse(localStorage.getItem('userInfo')).userId;
      let reviewerds=JSON.parse(localStorage.getItem('reviewerds'))
      if(this.isAdmin || this.isReviewerLeader||reviewerds.includes(userId.toString())||(userId.toString())===this.form.reviewer_id){
        return true
      }else{
        return false
      }
    },
    isReviewerActionDelete(status){
      let userId =JSON.parse(localStorage.getItem('userInfo')).userId;
      let arr=localStorage.getItem('reviewerds')
      if((this.isReviewer||arr.includes(userId.toString())) && this.step === 2 && (status === 0 || status === 1)){
        return true;
      }
      return false;
    },
    getPlanId(PlanId){
      this.meterspherePlanId = PlanId;
    },
    handleSelectionChange(val){
    },
    // 关闭任务弹窗
    handleTaskClose(info = '') {
      this.dialogVisibleTask = false;
    },
    // 跳转外链
    linkFn(url) {
      window.open(url)
    },
    async getHistoryList(){
      await getDevOpsSpaceHistoryTaskListApi({type:4,busiId: this.form.id}).then((res)=>{
        this.historylist = res.data;
      });
    },
    getNowDate(){
      var today = new Date();
      var year = today.getFullYear();//获取年份
      var month = today.getMonth() + 1;//获取月份
      var day = today.getDate();//获取日期
      let cmonth = month < 10 ? '0'+month : month;
      let cday = day < 10 ? '0' + day : day;
      return year + "-" + cmonth + "-" + cday;
    },
    //完成测试
    submitFinishTest(){
      let currentTime = Date.parse(this.getNowDate());
      let planFinishDate = Date.parse(this.form.planFinishDate);
      if(currentTime > planFinishDate){
        this.dialogVisibleDelay = true;
      }else{
        this.submitAction(7);
      }
    },
    submitUat(m){
      if(m){
        this.stage_liantiao=1
      }else{
        this.stage_liantiao=''
      }
      // let currentTime = Date.parse(this.getNowDate());
      // let planFinishDate = Date.parse(this.form.planFinishDate);
      // if(currentTime > planFinishDate){
      //   this.dialogVisibleDelay = true;
      // }else{
      //   this.submitAction(5,'production');
      // }
      this.submitAction(8,'production');
    },
    //提交延期原因
    onSubmitDelay(){
      this.$refs["pSubmitForm"].validate(async (valid) => {
        if (valid) {
          this.$set(this.loading, 'submitDelay', true);
          postDevOpsSpaceSUbmitDelayReasonApi({taskId: Number(this.formInfo.taskInfo.id),reasonCode: Number(this.pSubmitForm.reasonCode),reasonDetail: this.pSubmitForm.reasonDetail,type: 2,is_delay:1}).then((ret)=>{
            if(ret.status === 'success'){
              this.submitAction(7);
              this.dialogVisibleDelay = false;
              //this.submitAction(5,'production');
            }else{
              this.$notify({
                message: ret.message ||"提交失败",
                type: "error",
              })
            }
            this.loading.submitDelay = false;
          });
        }
      })
    },
    async submitAction(type,env = ''){
      if(type === 6){
        this.$set(this.loading, 'skip', true)
      }else{
        this.$set(this.loading, 'submit', true)
      }
      try {
        const { id = '' } = this.formInfo?.taskInfo || {};
        let params = {
          id:id,
          type:type,
        };
        if(this.stage_liantiao===1){
          params.stage_liantiao=1
        }
        if(env){
          params.env = env;
        }
        //跳过
        if(type === 6){
          //提交预发环境
          if(this.form.test_status === 4){
            params.stage_id = 7;
            params.stage_name = "tester_testCaseTest";
          }
          //提交uat
          if(this.form.test_status === 9){
            params.stage_id = 11;
            params.stage_name = "tester_stagCaseTest";
          }
        }
        if(type === 2 || type === 4 || type === 5){
          if(!this.meterspherePlanId){
            this.$notify({
              message: '请填写测试用例',
              type: "error",
            })
            return false;
          }
        }
        await postDevOpsSpaceSUbmitTestTaskApi(params).then((res)=>{
          if(res.status === 'success'){
            this.stage_liantiao=''
            this.$notify({
              message: res.message || "成功",
              type: "success",
            })
            if(this.form.test_status == 0 || this.form.test_status == 1 || this.form.test_status == 3 || this.form.test_status == 4 || this.form.test_status == 5 ){
              this.init();
              this.getHistoryList()
            }else{
              this.hideDialogVisible();
            }
            //this.hideDialogVisible();
          }else{
            this.$notify({
              message: res.message || "失败",
              type: "error",
            })
          }
        });
      } catch (error) {
        this.$notify({
          message: error || "网络错误",
          type: "error",
        })
        this.loading.submit = false;
        this.loading.skip = false;
      } finally {
        this.loading.submit = false;
        this.loading.skip = false;
      }

    },
    //预估工时只能正整数
    handleEdit(e) {
      let value = e.replace(/^(0+)|[^\d]+/g,''); // 以0开头或者输入非数字，会被替换成空
      value = value.replace(/(\d{15})\d*/, '$1') // 最多保留15位整数
      if(value > 30){
        value = 30;
      }
      this.form.estimateWorkHour = value
    },
    onAllocationTask(type,row){
      this.dialogVisibleAllocationTask = true;
    },
    changeDomain(e) {
      delete this.form.module;
    },
    linkToModel(row){
      this.formTaskInfo = {...row,taskId:row.id,name:row.taskName};
      this.dialogVisibleTask = true;
    },
    disabledDate(type, time) {
      const nowTime = Date.now() - 60 * 60 * 24 * 1000;
      const { psdt = '', pedt = '', pstt = '', pett = '', create_time = '', plt = '' } = this.form;
      switch (type) {
        case 'psdt':
          if (pedt) {
            return time.getTime() <= (new Date(create_time)).getTime() - 60 * 60 * 24 * 1000 || time.getTime() >= (new Date(pedt)).getTime()
          }
          if (pstt) {
            return time.getTime() <= (new Date(create_time)).getTime() - 60 * 60 * 24 * 1000 || time.getTime() >= (new Date(pstt)).getTime()
          }
          if (plt) {
            return time.getTime() <= (new Date(create_time)).getTime() - 60 * 60 * 24 * 1000 || time.getTime() >= (new Date(plt)).getTime()
          }
          return time.getTime() <= (new Date(create_time)).getTime() - 60 * 60 * 24 * 1000
        case 'pedt':
          if (psdt) {
            if (pstt) {
              return time.getTime() <= (new Date(psdt)).getTime() - 60 * 60 * 24 * 1000 || time.getTime() >= (new Date(pstt)).getTime()
            }
            if (plt) {
              return time.getTime() <= (new Date(psdt)).getTime() - 60 * 60 * 24 * 1000 || time.getTime() >= (new Date(plt)).getTime()
            }
            return time.getTime() <= (new Date(psdt)).getTime() - 60 * 60 * 24 * 1000
          }
          return time.getTime() <= nowTime
        case 'pstt':
          if (pedt) {
            if (plt) {
              return time.getTime() <= (new Date(pedt)).getTime() - 60 * 60 * 24 * 1000 || time.getTime() >= (new Date(plt)).getTime()
            }
            return time.getTime() <= (new Date(pedt)).getTime() - 60 * 60 * 24 * 1000
          }
          if (psdt) {
            if (plt) {
              return time.getTime() <= (new Date(psdt)).getTime() - 60 * 60 * 24 * 1000 || time.getTime() >= (new Date(plt)).getTime()
            }
            return time.getTime() <= (new Date(psdt)).getTime() - 60 * 60 * 24 * 1000
          }
          return time.getTime() <= nowTime
        case 'plt':
          if (pstt) {
            return time.getTime() <= (new Date(pstt)).getTime() - 60 * 60 * 24 * 1000
          }
          if (pedt) {
            return time.getTime() <= (new Date(pedt)).getTime() - 60 * 60 * 24 * 1000
          }
          if (psdt) {
            return time.getTime() <= (new Date(psdt)).getTime() - 60 * 60 * 24 * 1000
          }
          return time.getTime() <= nowTime
      }
    },
    // 初始化页面
    async init() {
      await this.queryDevOpsSpaceTaskDetail();
      //this.queryListMetersphereBugs();
    },
    getChooseTask(choose){
      this.addData = choose;
    },
    // 获取bug信息
    async queryListMetersphereBugs() {
      try {
        const ret = await getListMetersphereBugsApi({ tid: this.form.id })
        if (ret.status === 'success') {
          this.bugOption = {
            ...ret.count,
            count: ret.data?.length || 0,
            bugs: ret.data || []
          }
        } else {
          this.$notify({
            message: ret.message || '',
            type: "error",
          })
        }
      } catch (error) {
        this.$notify({
          message: error || "获取bug信息失败",
          type: "error",
        })
      }
    },
    // 获取任务详情
    async queryDevOpsSpaceTaskDetail() {
      this.loading.dialog = true;
      try {
        const ret = await getDevOpsSpaceTestTaskApi({
          taskId: this.formInfo.taskInfo.id || ""
        });
        const info = ret.data[0] || {};
        this.form = {
          ...this.form,
          ...info,
          taskDetail: info.taskContent,
          testerId: info.tester.id ? info.tester.id.toString(): '',
          test_status_desc:info.status.desc ? info.status.desc: '',
        };
        await this.DelayReasonList();
      } catch (error) {
        this.$notify({
          message: error || "获取任务详情失败",
          type: "error",
        })
      } finally {
        this.loading.dialog = false;
      }
    },
    // 获取任务详情
    async queryDevOpsSpaceDevelopTestTask() {
      this.loading.dialog = true;
      try {
        const ret = await getDevOpsSpaceDevelopTestTaskApi({
          testTaskId: this.formInfo.taskInfo.id || ""
        });
        if(ret.data.length > 0){
          this.addData = ret.data;
        }
      } catch (error) {
        this.$notify({
          message: error || "获取开发任务失败",
          type: "error",
        })
      } finally {
        this.loading.dialog = false;
      }
    },
    async DelayReasonList() {
      await getDevOpsSpaceDelayReasonListApi({type: 2}).then((ret) => {
        let arr = {};
        ret.data.forEach((item) => {
          arr[item.reasonCode] = item.reasonDesc;
        })
        this.typeList = arr;
      });
    },
    // 任务创建及更新
    async onSubmit() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          let devTaskIds = [];
          this.addData.forEach((v,i)=>{
            devTaskIds.push(v.id);
          });
          if(devTaskIds.length == 0){
            this.$notify({
              message: "请添加任务",
              type:  "error",
            })
            return false;
          }
          const {name,testerId,estimateWorkHour,planFinishDate,taskDetail} = this.form;
          let params = {name,testerId:Number(testerId),estimateWorkHour:Number(estimateWorkHour),planFinishDate,taskDetail,demandId:this.formInfo.id,devTaskIds: devTaskIds.toString()};
          if(!this.isCreate){
            params.id = this.formInfo.taskInfo.id;
            params.demandId = this.form.demand_id;
          }
          try {
            this.$set(this.loading, 'submit', true)
            const ret = !this.isCreate ? await postDevOpsSpaceUpdateTestTaskApi(params) : await postDevOpsSpaceCreateTestTaskApi(params);
            this.$notify({
              message: ret.message || "数据异常",
              type: ret.status === 'success' ? 'success' : "error",
            })
            ret.status === 'success' && this.hideDialogVisible();
            return false;
          } catch (error) {
            this.$notify({
              message: error || "数据异常",
              type: "error",
            })
            return false;
          } finally {
            this.loading.submit = false;
          }
        }
      })
    },
    onDeleteTestTask(row){
      this.addData = this.addData.filter(function (item) {
        return item.id !== row.id;
      });
      console.log(row);
    },
    // 格式化 props
    formatFormInfo(val) {
      if (val) {
        return val.split(',')
      }
      return []
    },
    changeDate() {
      this.$nextTick(() => {
        this.form.pett = this.form.plt
      })
    },
    // 关闭弹窗
    handleClose() {
      if(this.back){
        this.hideDialogVisible('demand')
      }else{
        this.hideDialogVisible()
      }

    },
    handleAllocationClose(){
      this.dialogVisibleAllocationTask = false;
    },
    toArrange(row){
      let type = '';
      let typeStatus=this.form.test_status
      if(typeStatus === 4||typeStatus=== 0||typeStatus=== 1||typeStatus===2 || typeStatus=== 3){
        type = 'dialogVisibleTestEnv';
      }else if(this.form.test_status === 5 || this.form.test_status === 9 ||  this.form.test_status === 10){
        type = 'dialogVisibleTestPreEnv';
      }else if(this.form.test_status === 6){
        type = 'dialogVisibleTestUatEnv';
      }
      this.arrangeInfo = {...row,tester:this.form.tester};
      this[type] = true;
    },
    addBugTask(row){
      this.dev_task_id = row.id;
      this.dialogVisibleCreateBug = true;
    },
    handleCreateBug(){
      this.queryDevOpsSpaceDevelopTestTask();
      this.dialogVisibleCreateBug = false;
    },
    handleTestEnvClose(){
      this.dialogVisibleTestEnv = false;
    },
    handleTestPreEnvClose(){
      this.dialogVisibleTestPreEnv = false;
    },
    handleTestUatEnvClose(){
      this.dialogVisibleTestUatEnv = false;
    },
    // 修改富文本内容
    changeContent(val) {
      this.form.details = val;
    },
    changeDescribeContent(val){
      this.form.describe = val;
    },
    // 任务删除
    onDelete() {
      this.$confirm("此操作将删除该需求, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        this.$set(this.loading, 'delete', true)
        try {
          const res = await postDevOpsSpaceDeleteTaskApi({
            id: this.form.id,
          });
          if (res.status === "success") {
            this.$notify({
              message: "删除成功",
              type: "success",
            })
            this.handleClose();
          } else {
            this.$notify({
              message: res.data.msg || "删除失败",
              type: "error",
            })
          }
        } catch (error) {
          this.$notify({
            message: error || "网络错误",
            type: "error",
          })
        } finally {
          this.loading.delete = false;
        }
      });
    },
    // 从编辑到提交 1 -> 2
    changeStep() {
      this.$nextTick(() => {
        this.$forceUpdate()
        this.$set(this, 'step', 2)
      })
    },
  }
};
</script>
<style lang="scss">
.task_model_dialog {

  .el-form-item__label {
    font-weight: bold;
  }

  .comment_warp {
    .comment_item>div {
      display: flex;
      margin: 0;
      margin-bottom: 12px;

      .el-textarea__inner {
        font-weight: bold;
      }
    }
  }

  .el-dialog__body {
    padding-bottom: 0;
  }

  // #region select
  .el-select__tags {
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE 10+ */
  }

  .el-select__tags::-webkit-scrollbar {
    display: none;
    /* Chrome Safari */
  }

  .el-input__inner {
    margin-left: -5px;
  }

  // #endregion select
}
 .el-form-item__label {
  font-weight: bold;
  font-size: 12px;
}
.task-line{
  height: 1px;
  border-top: 1px solid #ddd;
  text-align: center;
  margin-top: 20px;
}
.task-line label{
  position: relative;
  top: -8px;
  background: #fff;
  padding: 0 20px;
  font-weight: bold;
  color: #606266;
}
.table_text_click_new {
  text-decoration: underline;
  color: #409EFF;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
</style>
